<template>
  <div class="top-item">
    <img class="item-icon" :src="require('@/assets/' + info.icon + '.webp')" />
    <div class="item-title">{{ info.title }}</div>
    <div class="item-content">{{ info.content }}</div>
    <div class="item-btn" v-if="!!btnName" @click="handleClick">
      {{ btnName }}
    </div>
  </div>
</template>
<script setup>
import { defineProps } from "vue";
import { useRouter } from "vue-router";
const props = defineProps({
  info: {
    type: Object,
    required: true,
  },
  btnName: {
    type: String,
  },
  btnLink: {
    type: String,
  },
});

const router = useRouter();

const handleClick = () => {
  if (props.btnLink) {
    router.push(props.btnLink);
    window.scrollTo(0, 0);
  }
};
</script>
<style lang="less" scoped>
.top-item {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 20%;
  text-align: center;
  .item-icon {
    width: 100%;
    object-fit: contain;
  }

  .item-title {
    font-weight: bold;
    font-size: 18px;
    color: #252b42;
    line-height: 24px;
    margin-top: 10px;
  }

  .item-content {
    font-size: 11px;
    color: #737373;
    line-height: 15px;
    padding: 0 26px;
    font-weight: 400;
  }

  .item-btn {
    background: #ff561c;
    border-radius: 15px;
    background-color: rgba(255, 86, 28, 0.16);
    padding: 9px 27px;
    font-size: 11px;
    color: #ff561c;
    line-height: 12px;
    margin-top: 29px;
    cursor: pointer;
  }
}
</style>